<script lang="ts" setup>
import SortItems from '@/components/common/SortItems.vue';
import { Story, StoryType } from '@/models/story.model';
import { ShiftCMSState } from '@/store';
import { CategoriesState } from '@/stores/categories.store';
import { StoriesActions, StoriesState } from '@/stores/stories.store';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore<
  ShiftCMSState & { ts: StoriesState; cs: CategoriesState }
>();
const stories = computed<Story[]>(() => store.state.ts.stories);

onMounted(() => {
  store.dispatch(StoriesActions.GetStories);
});

const saveSorted = (storySorting: number[]) => {
  store.dispatch(StoriesActions.UpdateStorySorting, storySorting);
};
</script>
<template>
  <v-container>
    <h2>Quiz of the day - Sorting</h2>
    <v-alert type="info" class="mb-4">
      Sort the stories on this screen. Users will encounter these stories as
      quiz of the day, in this order, unless a preference for a specific
      category is set.
    </v-alert>
    <v-alert type="warning" class="mb-4">
      Changing the order here might give people strange results
    </v-alert>
    <div class="sorting">
      <SortItems
        show-id
        :items="
          [...stories]
            .filter((s) => s.published)
            .filter((s) => s.type === StoryType.Quiz)
        "
        :order="stories.sort((a, b) => a.index - b.index).map((s) => s.id)"
        @change="(ids: number[]) => saveSorted(ids)"
      />
    </div>
  </v-container>
</template>
<style scoped>
.sorting {
  max-width: 600px;
  margin: 0 auto;
}
</style>
